"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGenderString = void 0;
const isGenderString = (tag) => [
    "masculine",
    "neuter",
    "feminine",
    "het - neuter",
    "de - masculine/feminine",
].includes(tag);
exports.isGenderString = isGenderString;
//# sourceMappingURL=gender_utils.js.map